import { useState } from "react";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Icon from "@mui/material/Icon";

import MDTypography from "components/MDTypography";

/**
 * Per-row 3-dot action menu for entity tables.
 *
 * `actions` is an array of { label, icon?, color?, onClick }. Clicks are kept
 * from bubbling so they never trigger the DataGrid row click.
 */
function RowActionMenu({ actions }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const handleAction = (event, action) => {
    event.stopPropagation();
    setAnchorEl(null);
    action.onClick();
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen} aria-label="Row actions">
        <Icon>more_vert</Icon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {actions.map((action) => (
          <MenuItem key={action.label} onClick={(event) => handleAction(event, action)}>
            {action.icon && (
              <ListItemIcon>
                <Icon fontSize="small" color={action.color || "inherit"}>
                  {action.icon}
                </Icon>
              </ListItemIcon>
            )}
            <MDTypography
              variant="button"
              fontWeight="regular"
              color={action.color === "error" ? "error" : "text"}
            >
              {action.label}
            </MDTypography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

RowActionMenu.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      color: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default RowActionMenu;
